export default __webpack_public_path__ + "static/media/hazhozszallitas_CaffeMauro.52674c63.png";